// extracted by mini-css-extract-plugin
export default {"updateButton":"input-form-module__updateButton___cJrJj","link":"input-form-module__link___tkjlE","icon":"input-form-module__icon___F1stz"};